import React, { Component } from "react";

export default class Chooseus extends Component {
    render() {
        return (
            <div>
                <div className="featured-block">
                    <div className="inner-box">
                        <div className="content">
                            <div className="icon">
                                <img src={""} alt="" />
                            </div>
                            <h3>
                                
                                    {this.props.values}
                                
                            </h3>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
